<template>
  <div class="home">
    <div class="banner-home">
      <div class="overlay"></div>
      <video
        playsinline="playsinline"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
      >
        <source src="@/assets/banner_home.mp4" type="video/mp4" />
      </video>
      <div class="container h-100">
        <div class="d-flex h-100 text-right align-items-center">
          <div class="w-100 text-white">
            <p class="lead mb-0">مرحبا</p>
            <h1 class="mb-4">صلاح العلاج</h1>
            <p class="lead mb-0">
              مُحام و رئيس تحرير دروازة نيوز "و أشياء اخرى "
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="zoom-posts">
      <div class="container">
        <div class="zoom-posts__head">
          <div class="zoom-posts__title">مقالاتي</div>

          <router-link class="zoom-posts__more-link" to="/blog-list">
            عرض المزيد
            <b-icon icon="chevron-left"></b-icon>
          </router-link>
        </div>
        <div class="row">
          <div
            class="col-lg-4 col-xs-6 col-12"
            v-for="blog in blogs"
            v-bind:key="blog.id"
          >
            <div class="card mb-4">
              <router-link
                class="position-relative"
                v-bind:to="{
                  name: 'view-blogDetail',
                  params: { id: blog.id }
                }"
              >
                <img :src="blog.image" class="card-img-top" />
                <span
                  class="badge position-absolute badge-top-left badge-primary badge-pill"
                  >{{ blog.category }}</span
                >
              </router-link>
              <div class="card-body">
                <h6 class="mb-3 card-subtitle" style="height: 3rem;">
                  <router-link
                    class="secondary-content"
                    v-bind:to="{
                      name: 'view-blogDetail',
                      params: { id: blog.id }
                    }"
                  >
                    {{ blog.title }}
                  </router-link>
                </h6>
                <div class="card-meta">
                  <b-row align-h="between">
                    <b-col cols="8">
                      <p
                        class="card-text text-muted text-small mb-0 font-weight-light"
                      >
                        <b-icon icon="calendar"></b-icon>
                        {{ blog.date }}
                      </p>
                    </b-col>
                    <b-col cols="4"
                      ><p
                        class="card-text text-muted text-small mb-0 font-weight-light text-left"
                      >
                        <span> 10 </span>
                        <b-icon font-scale="2" icon="eye"></b-icon></p
                    ></b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="collapse-block">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 ">
            <div class="zoom-posts__head">
              <div class="zoom-posts__title">السيرة الذاتية</div>

              <router-link class="zoom-posts__more-link" to="/about">
                عرض المزيد
                <b-icon icon="chevron-left"></b-icon>
              </router-link>
            </div>
            <div role="tablist" class="collapse-list">

              <b-card no-body class="mb-1"  v-for="(bio) in biography" :key="bio.id" >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle="'collapse' + bio.id"   aria-expanded="true"  variant="link"
                    > {{bio.title}} <b-icon icon="chevron-down"></b-icon
                  ></b-button>
                </b-card-header>
                <b-collapse
                  :id="'collapse'+bio.id"
                  accordion="my-accordion"
                  role="tabpanel"
                  visible
                >
                  <b-card-body>
                    <b-card-text v-html="bio.content">
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div class="col-12 col-lg-5 offset-lg-1">
            <div>
              <div class="parallax">
                <div class="para-line-1"></div>
                <div class="para-line-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="videos-container">
      <div class="container">
        <div class="bg-video-player"></div>
        <div class="video-player" v-for="video in videosF"
              :key="video.id">
          <div class="video-line-1"></div>
          <div class="video-line-2"></div>
          <div class="video-line-3"></div>
          <b-embed
            type="iframe"
            aspect="16by9"
            :src="'https://www.youtube.com/embed/' + video.urlYoutube +'?autoplay=0&;enablejsapi=1&;rel=0'"
            allowfullscreen

          ></b-embed>
        </div>
        <div class="video-choices">
          <div class="row">
            <div
              class="col-lg-3 col-6 mt-4"
              v-for="video in videos"
              v-bind:key="video.id"
            >
              <div class="card">
                <router-link
                  class="position-relative"
                  v-bind:to="{
                    name: 'view-videoDetail',
                    params: { id: video.id }
                  }"
                >
                  <img :src="video.vd_image" class="card-img-top" />
                  <span class="play-video"
                    ><b-icon icon="play-fill"></b-icon
                  ></span>
                </router-link>
                <div class="card-body">
                  <h6 class="mb-3 card-subtitle">
                    <router-link
                      class="secondary-content"
                      v-bind:to="{
                        name: 'view-videoDetail',
                        params: { id: video.id }
                      }"
                    >
                      {{ video.title }}
                    </router-link>
                  </h6>
                  <div class="card-meta">
                    <b-row align-h="between">
                      <b-col cols="8">
                        <p
                          class="card-text text-muted text-small mb-0 font-weight-light"
                        >
                          <b-icon icon="calendar"></b-icon>
                          {{ video.date }}
                        </p>
                      </b-col>
                      <b-col cols="4"
                        ><p
                          class="card-text text-muted text-small mb-0 font-weight-light text-left"
                        >
                          <span> 10 </span>
                          <b-icon font-scale="2" icon="eye"></b-icon></p
                      ></b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center pt-4">
            <router-link to="/video-list" class="btn-style">
              عرض جميع الفديوهات
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="gallery">
      <b-container>
        <h1 class="text-center mb-5">#صلاح العلاج</h1>
        <vue-picture-swipe :items="items">
         </vue-picture-swipe>
      </b-container>
    </div>
  </div>
</template>
<script>
import db from "@/components/firebaseInit";
export default {
  data() {
    return {
      blogs: [],
      videos: [],
      videosF:[],
      video_url: "X8IRJaGDrRU" ,
      biography: [],
      gallery: [],
      items: [],
   }
  },
  created() {
    db.collection("blogs")
      .limit(3)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            title: doc.data().title,
            date: doc.data().date,
            category: doc.data().category,
            image: doc.data().image
          };
          this.blogs.push(data);
        });
      });
    db.collection("videos")
      .limit(4)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            title: doc.data().title,
            date: doc.data().date,
            vd_image: doc.data().poster,
            urlYoutube: doc.data().urlYoutube
          };
          this.videos.push(data);
        });
      });
    db.collection("biography")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            id: doc.id,
            title: doc.data().title,
            date: doc.data().date,
            content: doc.data().content
          };
          this.biography.push(data);
          this.isLoad = true;
        });
      });
    db.collection("gallery")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            const data = {
            title: doc.data().title,
            date: doc.data().date,
            src: doc.data().photo,
            thumbnail: doc.data().photo,
            w: 1200,
            h:900
          };
          this.items.push(data)
        });
        if(this.items.length==0){
          this.msg = 'No photo available right now..'
        }
      })
      .catch((error) => {
          console.log("Error getting photos: ", error);

      });
        db.collection("videos")
        .limit(1)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              urlYoutube: doc.data().urlYoutube
            };
            console.log(data)
            this.videosF.push(data);
          });
        });
  }
};
</script>
